import axios from 'axios';
import Datagent                              from 'datagent';
import {respondData, requestHandle, setYear} from '../utils';
import Fecha                                 from '../utils/type/Fecha';
import {defaults}                            from 'datagent/src/utils';

const {filter, format, getField, awaitTo} = Datagent.Hooks;

export const DateFormat = Fecha.format('YYYY-MM-DD HH:mm:ss');
export const DateParse  = Fecha.parse('YYYY-MM-DD HH:mm:ss');

const name  = 'carbonReport/list';
const Model = Datagent.Model({
    name,
    fields : {
        'id' : {type: Number, default: null},            //公司id
        'abbreviation': {type: String, default: ''},     //公司简称
        'companyName': {type: String, default: ''},     //公司全称
        'stockCode': {type: String, default: ''},        //股票代码
        'title' : {type: String, default: ''},           // 报告标题
        'savePath' : {type: String, default: ''},        //服务器保存路径
        'originalAddress' : {type: String, default: ''}, // 报告原下载路径
        'year' : {type: Number, default: ''},            // 年份
        'postTime' : {type: String, default: ''},        // 报告发布时间
    },
    methods: {
        fetch(params, opts){
          const { origin } = defaults(opts);
          return this.remote(origin).get(this._url, params);
        }, 
        destroy(params, opts){
          const { origin } = defaults(opts);
          const { id, ...query } = params;
          if(typeof id == 'undefined') throw new Error('The id must be have of params!')
          return this.remote(origin).delete(this._url+`/${id}`, {id});
        },
        upload(params, opts){
          const { origin } = defaults(opts);
          let { file, publishDate, ...query } = params;
          if(typeof file == 'undefined') throw new Error('The file must be have of params!')


          const data = new FormData()
          data.append('file', file)

          const source = axios.CancelToken.source();

          return Promise.resolve({
            action: progress=>{
              return this.remote(origin).sync({
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                },
                url: 'report/upload',
                method: 'POST',
                params: { ...query, publishDate },
                data,
                cancelToken: source.token,
                onUploadProgress: progress
              })
            },
            cancel: source.cancel
          })
        },
        ossSetting(params, opts){
          const { origin } = defaults(opts);
          return this.remote(origin).get(`/report/ossSetting`, params);
        },
        uploadRecord(params, opts){
          const { origin } = defaults(opts);
          return this.remote(origin).post(`/report/uploadRecord`, params);
        },
    },
    hooks  : {
        fetch              : {after: [respondData(), requestHandle()]},
        find               : {after: [respondData(), requestHandle()]},
        destroy            : {after: [respondData(), requestHandle()]},
        ossSetting         : {after: [respondData(), requestHandle()]},
        uploadRecord         : {after: [respondData(), requestHandle()]}
    }
});

Model.ModelName   = name;
export default Model;
